import { create, unpackActions } from 'zustand-toolbox';

import { actions } from './actions';
import type { TStore } from './types';

export const [useUserStore] = create<TStore>((set) => ({
    user: null,
    isLoading: false,

    ...unpackActions(actions, set),
}));
